<template>
    <div class="form-group mb-0">
        <label class="form-group-label">{{ translate.user_features.date_of_birth }}</label>
        <div class="d-flex g-2">
            <select class="form-control mr-2 text-capitalize" v-model="month">
                <option :value="null" hidden disabled>{{ translate.product.month }}</option>
                <option :value="month" v-for="month in 12">{{month}}</option>
            </select>
            <select class="form-control text-capitalize" v-model="year">
                <option :value="null" hidden disabled>{{ translate.product.year }}</option>
                <option :value="year" v-for="year in generateYears()">{{year}}</option>
            </select>
        </div>
    </div>
</template>

<script>
const data = () => {
    return {
        moment: moment,
        month: null,
        year: null,
    }
};

/**
 * Emits combined date to model
 */
function combineDate() {
    if (this.month && this.year) {
        const combinedDate = this.moment(`01-${this.month}-${this.year}`, 'DD-MM-YYYY');
        this.$emit('input', combinedDate.format('YYYY-MM-DD'));
    }
}

/**
 * Generated years so user can be only between 18 and 65
 */
function generateYears() {
    const currentYear = this.moment().year();
    const years = [];

    const minEligibleYear = currentYear - 65;
    const maxEligibleYear = currentYear - 18;

    for (let year = maxEligibleYear; year >= minEligibleYear; year--) {
        years.push(year);
    }

    return years;
}

export default {
    data,
    props: {
        value: String
    },
    watch: {
        month: 'combineDate',
        year: 'combineDate',
        value: {
            immediate: true,
            handler(newDate) {
                if (newDate) {
                    const dateMoment = this.moment(newDate, 'YYYY-MM-DD');
                    this.month = dateMoment.month() + 1;
                    this.year = dateMoment.year();
                }
            }
        }
    },
    methods: {
        combineDate,
        generateYears,
    },
    computed: {
        ...mapState(['translate'])
    },
}
</script>
